import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import FeeSystemMenu from "./FeeSystemMenu";

function AdvanceAdjustedInMonthReport(props) {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [totalAdjusted, setTotalAdjusted] = useState(0);
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());

  const months = [
    { value: 1, label: "Jan" }, { value: 2, label: "Feb" }, { value: 3, label: "Mar" },
    { value: 4, label: "Apr" }, { value: 5, label: "May" }, { value: 6, label: "Jun" },
    { value: 7, label: "Jul" }, { value: 8, label: "Aug" }, { value: 9, label: "Sep" },
    { value: 10, label: "Oct" }, { value: 11, label: "Nov" }, { value: 12, label: "Dec" },
  ];
  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

  const loadReport = () => {
    if (!month || !year) return;
    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "ADLedger/GetAdvanceAdjustedInMonthReport",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey: AccessKey,
        UserID: UserID,
        MemberType: MemberType || "Admin",
        SelectedMonth: parseInt(month, 10),
        FYear: parseInt(year, 10),
      },
    })
      .then((response) => {
        if (response.data.status_code == 1) {
          setList(response.data.ListofRecords || []);
          setTotalAdjusted(response.data.TotalAdjustedInMonth || 0);
        } else {
          setList([]);
          setTotalAdjusted(0);
          toast.error(response.data.status_message || "Failed to load report.", { position: toast.POSITION.TOP_RIGHT });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network Error.", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  useEffect(() => {
    document.title = "Advance Adjusted in Month Report";
    loadReport();
  }, []);

  return (
    <>
      <FeeSystemMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                  <li className="breadcrumb-item"><Link to="/FeeSystem/FeeSystemDashboard">Fee System</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">Advance Adjusted in Month</li>
                </ol>
              </nav>
              <div className="page-title">Advance Adjusted in Month Report</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions d-flex align-items-center gap-2">
                <select className="form-select" style={{ width: "100px" }} value={month} onChange={(e) => setMonth(parseInt(e.target.value, 10))}>
                  {months.map((m) => (
                    <option key={m.value} value={m.value}>{m.label}</option>
                  ))}
                </select>
                <select className="form-select" style={{ width: "100px" }} value={year} onChange={(e) => setYear(parseInt(e.target.value, 10))}>
                  {years.map((y) => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
                <button type="button" className="button button-white button-icon" onClick={loadReport} disabled={loading}>
                  Load
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <div className="mb-3">
                <strong>Total advance adjusted in {months.find(m => m.value === month)?.label} {year}:</strong> {Number(totalAdjusted).toLocaleString()}
              </div>
              <table className="table table-theme table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Reg No</th>
                    <th>Student Name</th>
                    <th>Fee Code</th>
                    <th>Description</th>
                    <th>Amount Adjusted</th>
                    <th>Received Date</th>
                    <th>Challan No</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="8" className="text-center"><Spinner animation="border" /></td></tr>
                  ) : list.length === 0 ? (
                    <tr><td colSpan="8" className="text-center text-muted">No advance adjusted in this month.</td></tr>
                  ) : (
                    list.map((item, idx) => (
                      <tr key={item.ID || idx}>
                        <td>{idx + 1}</td>
                        <td>{item.Registration_No}</td>
                        <td>{item.Student_Name}</td>
                        <td>{item.FeeCode}</td>
                        <td>{item.Description}</td>
                        <td>{Number(item.AmountAdjusted).toLocaleString()}</td>
                        <td>{item.ReceivedDate || "-"}</td>
                        <td>{item.Challan_No || "-"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdvanceAdjustedInMonthReport;
